'use strict';

var uncurryThis = require('../internals/function-uncurry-this');
module.exports = uncurryThis([].slice);